import { jsx } from "react/jsx-runtime";
import * as React from "react";
import { cx } from "../internal/cx.js";
import { withVars, toLength } from "./styleVars.js";
function avatarInitials(name) {
  const trimmed = name.trim();
  const source = trimmed.includes("@") && !/\s/.test(trimmed) ? trimmed.split("@")[0] ?? "" : trimmed;
  const letters = source.split(/[\s._-]+/).map((word) => /[\p{L}\p{N}]/u.exec(word)?.[0]).filter((letter) => Boolean(letter));
  if (letters.length === 0) return "";
  const first = letters[0] ?? "";
  const last = letters.length > 1 ? letters[letters.length - 1] ?? "" : "";
  return (first + last).toLocaleUpperCase();
}
const Avatar = React.forwardRef(function Avatar2({ name, initials, size, decorative = false, className, style, "aria-label": ariaLabel, ...rest }, ref) {
  const text = initials ?? avatarInitials(name);
  const label = ariaLabel ?? name.trim();
  const hidden = decorative || label === "";
  return /* @__PURE__ */ jsx(
    "span",
    {
      ref,
      className: cx("ev-avatar", className),
      role: hidden ? void 0 : "img",
      "aria-label": hidden ? void 0 : label,
      "aria-hidden": hidden ? true : void 0,
      style: withVars(style, { "--ev-avatar-size": size != null ? toLength(size) : void 0 }),
      ...rest,
      children: text
    }
  );
});
export {
  Avatar,
  avatarInitials
};
//# sourceMappingURL=Avatar.js.map
